import { Cache } from "../Cache";

const formatVidTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${String(minutes).length === 1 ? "0" + String(minutes) : seconds}:${String(seconds).length === 1 ? "0" + String(seconds) : seconds}`;
};

const DrawIcon = (ctx, _icons, type, x, y) => {
    // iconImage is 48x160px in size.
    // each icon is 48x40.
    // iconImage contains 4 icons.
    let i = 0;
    switch (type) {
        case "pause":
            i = 0;
            break;
        case "play":
            i = 1;
            break;
        case "mute":
            i = 2;
            break;
        case "unmute":
            i = 3;
            break;
        default:
            break;
    }
    if (_icons) {
        ctx.drawImage(_icons, 0, 40 * i, _icons.width, 40, x - 24, y - 20, 48, 40);
    }
};

export const VideoPlayer = (ctx, config, moment, _video, _icons) => {
    const _width = moment.width * moment.scale;
    const _height = moment.height * moment.scale;

    // footer gradient
    // Create gradient
    const gradient = ctx.createLinearGradient(0, _height * 0.5 - 100, 0, _height * 0.5);
    gradient.addColorStop(0, "rgba(0,0,0,0)");
    gradient.addColorStop(1, "rgba(0,0,0,0.75)");

    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.fillRect(-_width * 0.5, _height * 0.5 - 100, _width, 100);

    // time label
    if (_video && moment.isCurrent) {
        ctx.closePath();
        DrawIcon(ctx, Cache.loaded[_icons], _video.paused ? "play" : "pause", -_width * 0.5 + 50, _height * 0.5 - 40);
        DrawIcon(ctx, Cache.loaded[_icons], _video.muted ? "mute" : "unmute", _width * 0.5 - 50, _height * 0.5 - 40);

        ctx.textAlign = "center";
        ctx.fillStyle = config.video.colour;
        ctx.font = config.video.font;
        ctx.fillText(formatVidTime(_video.currentTime) + "/" + formatVidTime(moment.media.videoDuration), _width * -0.5 + 160, _height * 0.5 - 30, 160);
        //
        //
        // check if moment is large enough to show progress bar
        //
        if (_width > 500) {
            const progress = _video.currentTime / _video.duration;
            ctx.beginPath();
            ctx.lineCap = "round";
            ctx.moveTo(-_width * 0.5 + 260, _height * 0.5 - 40);
            ctx.lineTo(_width * 0.5 - 100, _height * 0.5 - 40);
            ctx.strokeStyle = "rgba(255,255,255,0.33)";
            ctx.lineWidth = 10;
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.lineCap = "round";
            ctx.moveTo(-_width * 0.5 + 260, _height * 0.5 - 40);
            ctx.lineTo(-_width * 0.5 + 260 + (_width - 360) * progress, _height * 0.5 - 40);
            ctx.strokeStyle = "rgba(255,255,255,1)";
            ctx.lineWidth = 6;
            ctx.stroke();
            ctx.closePath();
        }
    } else {
        ctx.textAlign = "right";
        ctx.fillStyle = config.video.colour;
        ctx.font = config.video.font;
        ctx.fillText(formatVidTime(moment.media.videoDuration), _width * 0.5 - config.video.padding, _height * 0.5 - config.video.padding, 200);
    }
};
